import classNames from 'classnames';

import { ButtonProps } from './button.types';
import { BUTTON_VARIANT_FILTER, BUTTON_VARIANT_M, BUTTON_VARIANT_OUTLINE, BUTTON_VARIANT_S } from './config';

export const Button = ({
  children,
  type = 'button',
  className = '',
  disabled,
  paddingClasses,
  borderClasses,
  roundClasses = 'rounded-md',
  dataTestId,
  variant = BUTTON_VARIANT_M,
  ...props
}: ButtonProps) => {
  return (
    <button
      className={classNames(
        'inline-flex items-center justify-center',
        className,
        {
          'cursor-pointer': !disabled,
          'cursor-not-allowed': disabled,
          'text-action-button-s': variant !== BUTTON_VARIANT_M,
          'text-action-button-m': variant === BUTTON_VARIANT_M,
          'px-8 py-3': variant === BUTTON_VARIANT_M || variant === BUTTON_VARIANT_FILTER,
          'px-4 py-2': variant === BUTTON_VARIANT_S || variant === BUTTON_VARIANT_OUTLINE,
        },
        roundClasses,
        borderClasses ? borderClasses : 'border-none'
      )}
      type={type}
      disabled={disabled}
      data-testid={dataTestId}
      {...props}>
      {children}
    </button>
  );
};
